import React from 'react';
import Utilisateurs from './Utilisateurs';

export default class Clients extends React.Component {
    render() {
        return <Utilisateurs auth={this.props.auth} isClients={true} isLoading={this.props.isLoading} />;
    }
}